import React, { useEffect, useRef } from 'react';
import { Landmark } from '@mediapipe/tasks-vision';

interface WebcamOverlayProps {
    landmarks: {
        face: Landmark[][];
        pose: Landmark[][];
        hands: Landmark[][];
    };
    videoRef: React.RefObject<HTMLVideoElement>;
}

export const WebcamOverlay: React.FC<WebcamOverlayProps> = ({ landmarks, videoRef }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const draw = () => {
            const canvas = canvasRef.current;
            const video = videoRef.current;
            if (!canvas || !video) return;

            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            // Sync canvas size with video display size
            const rect = video.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = rect.height;

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Hand Landmark drawing removed as per user request

        };

        const animationId = requestAnimationFrame(draw);
        return () => cancelAnimationFrame(animationId);
    }, [landmarks, videoRef]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 5,
                transform: 'scaleX(-1)' // Mirror to match video
            }}
        />
    );
};
